import { type UseWriteFragmentInteropResult } from '@confluence/apollo-relay-interop/entry-points/useWriteFragmentInterop.ts';
import { type UseReadFragmentInteropResult } from '@confluence/apollo-relay-interop/entry-points/useReadFragmentInterop.ts';

import type { useSpacesDataStarredSpacesQuery$data } from './__generated__/useSpacesDataStarredSpacesQuery.graphql.ts';

export type useSpacesDataStarredSpacesQuery_PaginatedSpaceList =
	useSpacesDataStarredSpacesQuery$data['spaces'];
export type useSpacesDataStarredSpacesQuery_PaginatedSpaceList_Space = NonNullable<
	NonNullable<useSpacesDataStarredSpacesQuery_PaginatedSpaceList>['nodes']
>[0];

export const updateStarredSpacesList = (
	spaceId: string,
	isStarred: boolean,
	readCurrentSpace: UseReadFragmentInteropResult<useSpacesDataStarredSpacesQuery_PaginatedSpaceList_Space>,
	readStarredSpaces: UseReadFragmentInteropResult<useSpacesDataStarredSpacesQuery_PaginatedSpaceList>,
	writeStarredSpacesFragment: UseWriteFragmentInteropResult<useSpacesDataStarredSpacesQuery_PaginatedSpaceList>,
) => {
	const space = readCurrentSpace({
		id: `Space:${spaceId}`,
	});

	try {
		const starredSpaces =
			readStarredSpaces({
				id: `$ROOT_QUERY.spaces(${JSON.stringify({ favourite: true, first: 30, status: 'current' })})`,
			})?.nodes || [];
		let newStarredSpaces;
		if (isStarred) {
			newStarredSpaces = [...starredSpaces, space];
			newStarredSpaces.sort((a, b) => (!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name)));
		} else {
			newStarredSpaces = starredSpaces.filter((s: any) => s?.id !== spaceId);
		}

		writeStarredSpacesFragment({
			fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({ favourite: true, first: 30, status: 'current' })})`,
			data: { nodes: newStarredSpaces, __typename: 'PaginatedSpaceList' },
		});
	} catch {
		// If Apollo throws an error, the starred spaces data was not found in the cache.
		// Errors can be safely ignored as if there is no cache entry, there is no work to be done.
	}
};
